module.exports = __webpack_public_path__ + "img/contactDetails.6f5ccee7.svg";